/**
 * Billing module i18n translations
 */

import { en } from './locales/en'
import { pl } from './locales/pl'

export const billingTranslations = {
  en,
  pl,
}
